import React from 'react'
import PropTypes from 'prop-types'

import { Heading } from 'Components/Blocks/_Legacy'
import { SwiperNarrow, SwiperWide } from 'Components/Blocks/_Legacy/Swipers'
import { Motion, Wrapper } from 'Components/UI'

import { chatGlyph } from 'Assets/_Legacy/BlockchainPage/icons'

import { BLOCKCHAIN_TESTIMONIALS } from 'Constants/ClientsFeedback'
import { SWIPER_KINDS } from 'Constants/Swipers'

import { Container, Content } from './styles'

function Testimonials({ data }) {
  return (
    <Container>
      <Wrapper wayPointTop>
        <Content>
          <Motion>
            <Heading
              mb={[56, 56, 64, 64, 88]}
              subTitleText={data?.subtitleText}
              tagGlyph={chatGlyph}
              tagText={data?.overheadText}
              tagTextAs="h4"
              titleText={{
                first: {
                  text: data?.titleTextFirst,
                  bold: data?.firstBold,
                },
                second: {
                  text: data?.titleTextSecond,
                  bold: data?.secondBold,
                },
              }}
              titleTextAs="h3"
            />

            <SwiperWide
              data={BLOCKCHAIN_TESTIMONIALS}
              kind={SWIPER_KINDS.TESTIMONIALS}
              slidesPerView={1}
            />

            <SwiperNarrow
              data={BLOCKCHAIN_TESTIMONIALS}
              kind={SWIPER_KINDS.TESTIMONIALS}
            />
          </Motion>
        </Content>
      </Wrapper>
    </Container>
  )
}

Testimonials.defaultProps = {
  data: {},
}

Testimonials.propTypes = {
  data: PropTypes.object,
}

export default Testimonials
